import { translations } from "../content/translations.js";
import { languages } from "../company";

//let lang = localStorage.getItem("user_language");
let lang = "en";
if (!lang) {
  lang = Object.keys(languages).find((language) => language === navigator.language?.slice(0, 2)) || "en";
  localStorage.setItem("user_language", lang);
}


const calcFullSizeQty = (length, cornerQuantity, overlap) => ((length - cornerQuantity * (8 - 2 * overlap)) / 100) * (1 + overlap / 100)
const calcEdgeSizeQty = (width, length, quantity, overlap) => (((length + width) * 2 * quantity) / 100) * (1 + overlap / 100)

const calculateResRow = (width, height, length, cornerQuantity, overlap, extraWidth) => {
    const result = {
        method: "",
        size: "",
        ff50RollQty: 0,
        ff50CornerQty: 0,
        ff62RollQty: 0,
        ff62CornerQty: 0,
        ff74RollQty: 0,
        ff74CornerQty: 0
    }

    if (width && height) {
        switch (true) {
            case (width + height * 2 + extraWidth <= 50):
                result.method = 'full'
                result.size = 'FF50'
                result.ff50RollQty = calcFullSizeQty(length, cornerQuantity, overlap)
                result.ff50CornerQty = cornerQuantity
                break
            case (width + height * 2 + extraWidth > 50 && width + height * 2 + extraWidth <= 62):
                result.method = 'full'
                result.size = 'FF62'
                result.ff62RollQty = calcFullSizeQty(length, cornerQuantity, overlap)
                result.ff62CornerQty = cornerQuantity
                break
            case (width + height * 2 + extraWidth > 62 && width + height * 2 + extraWidth <= 74):
                result.method = 'full'
                result.size = 'FF74'
                result.ff74RollQty = calcFullSizeQty(length, cornerQuantity, overlap)
                result.ff74CornerQty = cornerQuantity
                break
            case (width + height * 2 + extraWidth > 74 && height <= 50 / 2):
                result.method = 'edge'
                result.size = 'FF50'
                result.ff50RollQty = calcEdgeSizeQty(length, overlap)
                result.ff50CornerQty = 0
                break
            case (width + height * 2 + extraWidth > 74 && height <= 62 / 2):
                result.method = 'edge'
                result.size = 'FF62'
                result.ff62RollQty = calcEdgeSizeQty(length, overlap)
                result.ff62CornerQty = 0
                break
            case (width + height * 2 + extraWidth > 74 && height <= 74 / 2):
                result.method = 'edge'
                result.size = 'FF74'
                result.ff74RollQty = calcEdgeSizeQty(length, overlap)
                result.ff74CornerQty = 0
                break
            case (width + height * 2 + extraWidth > 74 && height > 74 / 2):
                alert('Contact Fab-Form (888)303-3278 to discuss deep footings')
                break
        }
    }

    return result
}

const calculateComRow = (width, height, length, quantity, overlap) => {
    const result = {
        method: "",
        size: "",
        ff50RollQty: 0,
        ff50CornerQty: 0,
        ff62RollQty: 0,
        ff62CornerQty: 0,
        ff74RollQty: 0,
        ff74CornerQty: 0
    }

    const dubleHeight = height * 2

    switch (true) {
        case (dubleHeight <= 50):
            result.method = 'edge'
            result.size = 'FF50'
            result.ff50RollQty = calcEdgeSizeQty(width, length, quantity, overlap)
            result.ff50CornerQty = 0
            break
        case (dubleHeight > 50 && dubleHeight <= 62):
            result.method = 'edge'
            result.size = 'FF62'
            result.ff62RollQty = calcEdgeSizeQty(width, length, quantity, overlap)
            result.ff62CornerQty = 0
            break
        case (dubleHeight > 62 && dubleHeight <= 74):
            result.method = 'edge'
            result.size = 'FF74'
            result.ff74RollQty = calcEdgeSizeQty(width, length, quantity, overlap)
            result.ff74CornerQty = 0
            break
        case (dubleHeight > 74):
            alert('Contact Fab-Form (888)303-3278 to discuss deep footings')
            break
    }

    return result
}

const getInputsData = (form, columns, overlap, extraWidth, type) => {
    let result = [];
    do {
        const width = +form[`width-${columns}`].value;
        const height = +form[`height-${columns}`].value;
        const length = +form[`length-${columns}`].value;
        const qty = +form[`qty-${columns}`].value;

        result.push(
            type === 'commercial'
            ? calculateComRow(width, height, length, qty, overlap)
            : calculateResRow(width, height, length, qty, overlap, extraWidth)
        );
        columns -= 1;
    } while(columns > 0);

    return result.reverse();
}

const sumColumns = (inputsData, column) => {
    const qty = inputsData.reduce((acc, curr) => acc + curr[column], 0)
    return qty > 0 ? qty : 0
}

const setResultData = (form, inputsData, columns) => {
    do {
        const method = form.querySelector(`#method-${columns}`)
        const size = form.querySelector(`#size-${columns}`)
        const quantity = form.querySelector(`#quantity-${columns}`)
        const roll = form.querySelector(`#roll-${columns}`) 
                                                                                                                                                                                                                                                                                                                                                    
        method && (method.innerText = inputsData[columns-1].method)
        size && (size.innerText = inputsData[columns-1].size)
        const qty = Math.ceil(inputsData[columns-1].ff50CornerQty + inputsData[columns-1].ff62CornerQty + inputsData[columns-1].ff74CornerQty)
        quantity && (quantity.innerText = qty > 0 ? qty : 0)
        const rollQty = Math.ceil(inputsData[columns-1].ff50RollQty + inputsData[columns-1].ff62RollQty + inputsData[columns-1].ff74RollQty)
        roll && (roll.innerText = rollQty > 0 ? rollQty : 0)

        columns -= 1
    } while (columns > 0)
}


export const calculateFastfoot = (type) => {
    const extraWidth = 10;
    const overlap = 1.0;
    const form = document.querySelector("#calc_ff_form");
    const widthInputRow = form.querySelector("#widthInputRow");
    const columnQty = widthInputRow.childElementCount - 1;
    const inputsData = getInputsData(form, columnQty, overlap, extraWidth, type);

    setResultData(form, inputsData, columnQty)
}

const getPrices = async () => {
    const response = await fetch("/get-prices", {method: "GET"})
    if (response.status === 200) {
      const data = await response.text()
      const parsedPage =  new DOMParser().parseFromString(data, 'text/html')
      const lumberElement = parsedPage?.body.querySelector('.price-section__current-value')
      const lumberPrice = +lumberElement?.innerText
      const lumberInput = document.querySelector("#lumberCost")
      lumberPrice && lumberInput && (lumberInput.value = Math.round(lumberPrice))
    }
}
  
const hintLogic = () => {
    const questionMarks = document.querySelectorAll(".question-mark");

    questionMarks.forEach(questionMark => {
        const hint = document.querySelector(`.hint-${questionMark.id}`);

        const hideHintOnClickOutside = (event) => {
        if (!hint.contains(event.target) && !questionMark.contains(event.target)) {
            hint.style.display = "none";
            document.removeEventListener("click", hideHintOnClickOutside);
        }
        };

        questionMark.onclick = (e) => {
        e.stopPropagation();
        const isVisible = hint.style.display === "block";
        hint.style.display = isVisible ? "none" : "block";

        if (!isVisible) {
            setTimeout(() => {
            document.addEventListener("click", hideHintOnClickOutside);
            }, 0);
        }
        };
    });
};

const addResultColumn = () => {
    const header = document.querySelector("#headerResultRow");
    const method = document.querySelector("#methodResultRow");
    const size = document.querySelector("#sizeResultRow");
    const qty = document.querySelector("#qtyResultRow");
    const roll = document.querySelector("#rollResultRow");
  
    const headerCell = document.createElement('th');
    const methodCell = document.createElement('td');
    const sizeCell = document.createElement('td');
    const qtyCell = document.createElement('td');
    const rollCell = document.createElement('td');
  
    headerCell.innerText = `#${header.childElementCount}`;
    methodCell.id = `method-${method.childElementCount}`;
    sizeCell.id = `size-${size.childElementCount}`;
    qtyCell.id = `quantity-${qty.childElementCount}`;
    rollCell.id = `roll-${roll.childElementCount}`;
  
    header.appendChild(headerCell);
    method.appendChild(methodCell);
    size.appendChild(sizeCell);
    qty.appendChild(qtyCell);
    roll.appendChild(rollCell);
}

const addInputColumn = (width, height, length, qty) => {
    const inputWidth = document.createElement('input');
    const inputHeight = document.createElement('input');
    const inputLength = document.createElement('input');
    const inputQty = document.createElement('input');
  
    inputWidth.id = `width-${width.childElementCount}`;
    inputHeight.id = `height-${height.childElementCount}`;
    inputLength.id = `length-${length.childElementCount}`;
    inputQty.id = `qty-${qty.childElementCount}`;
    inputWidth.type = "number";
    inputHeight.type = "number";
    inputLength.type = "number";
    inputQty.type = "number";
  
    inputWidth.classList.add("calc-ft-input", "input-width", "me-2");
    inputHeight.classList.add("calc-ft-input", "input-width", "me-2");
    inputLength.classList.add("calc-ft-input", "input-width", "me-2");
    inputQty.classList.add("calc-ft-input", "input-width", "me-2");
  
    width.appendChild(inputWidth);
    height.appendChild(inputHeight);
    length.appendChild(inputLength);
    qty.appendChild(inputQty);
  
    addResultColumn();
}

export const addFields = () => {
    const widthRow = document.querySelector("#widthInputRow");
    const heightRow = document.querySelector("#heightInputRow");
    const lengthRow = document.querySelector("#lengthInputRow");
    const qtyRow = document.querySelector("#qtyInputRow");
    if (widthRow.childElementCount < 4) {
        addInputColumn(widthRow, heightRow, lengthRow, qtyRow)
    }
}


export const fastFootEstimator = () => {
    const form = document.querySelector("#calc_ff_form");

    if (form) {
        getPrices();
        hintLogic();
    }
}

export const calculateFabric = (calc) => {
	const wallThickness = Number(calc.wallThickness.value);
	const slumpFactor = 0.8
	const block = Number(calc.block.value);
	const footingWidth = Number(calc.footingWidth.value);
	const footingHeight = Number(calc.footingHeight.value);
	const fabricWidth = 2 * footingWidth + Math.PI * footingHeight * slumpFactor + 6 - wallThickness - block * 2;

	const calculateFoldDistance = (ff) => {
		return Math.round(((ff-fabricWidth) / 2 + 1.5 ) * 10 ) / 10;
	}

	if (fabricWidth < 50) {
			calc.fastfootWidth.value = "FF50";
			calc.foldDistance.value = calculateFoldDistance(50);
	}  else if ((fabricWidth >= 50) && (fabricWidth < 62)) {
			calc.fastfootWidth.value = "FF62";
			calc.foldDistance.value = calculateFoldDistance(62);
	} else {
			if ((fabricWidth >= 62) && (fabricWidth < 74)) {
				calc.fastfootWidth.value = "FF74";
				calc.foldDistance.value = calculateFoldDistance(74);
			} else {
				alert("Contact Fab-Form regarding larger footing sizes.")
			}
	}
}

